/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { useHistory } from "react-router-dom";
import { Form, Row, Col, Radio, Select, Space } from "antd";
import { useForm } from "antd/lib/form/util";
import {
  UserOutlined,
  NumberOutlined,
  MinusCircleOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import {
  Typography,
  Divider,
  Input,
  DatePicker,
  TextArea,
  Button,
  Loading,
  RadioGroup,
} from "../core";
import { theme } from "../styles";

import { getAllBuyers } from "../helper/utils/api/buyer";
import { addConvertionContract } from "../helper/utils/api/contract";
import {
  getAllClothQualities,
  getAllWeave,
  getAllSelvedge,
} from "../helper/utils/api/settings";

const Notify_Utils = require("../helper/utils/Notification");

const { Option } = Select;
const { colors } = theme;
const FIXED_TO = require("../helper/utils/Fixed");

const layout = {
  labelCol: {
    span: 24,
  },
  wrapperCol: {
    span: 24,
  },
};

const CalContainer = styled.div`
  background: ${colors.darkBlue};
  padding: 20px;
  border-radius: 20px;
  && {
    .ant-input-lg,
    input,
    ::placeholder {
      font-weight: 500 !important;
      font-size: 20px;
    }
  }

  input {
    color: #ba3d79 !important;
  }
  input::placeholder {
    color: #ba3d79 !important;
  }
  label {
    color: white !important;
  }
`;

const StyledForm = styled(Form)`
  label,
  .buttton_btn,
  .buttton_btn:hover {
    font-weight: 500;
    font-size: 18px;
    line-height: 27px;

    color: ${colors.darkPink};
  }
  .buttton_btn {
    padding: 0px;
  }
`;

const ConversionContract = () => {
  let pick = 0;
  let width = 0;
  let reed = 0;
  let ratePerPick = 0;
  let warpCountMargin = 0;
  let warpweight = 0;
  let warpRate = 0;
  let weftCountMargin = 0;
  let weftweight = 0;
  let weftRate = 0;
  let conversionRate = 0;
  let warpAvg = 0;
  let weftAvg = 0;
  let fabricRatePerMeter = 0;
  let totalWeight = 0;

  const history = useHistory();

  const [form] = useForm();

  let companyId = localStorage.getItem("companyId");

  const [isLoading, setIsLoading] = useState(false);

  const [state, setState] = useState({
    buyers: [],
    buyerOption: [],

    weave: [],
    weaveOptions: [],

    selvedge: [],
    selvedgeOptions: [],

    clothQualities: [],
    clothQualitiesOptions: [],
  });

  const contract = {
    companyId: companyId,
    type: "conversion",
    contractNo: "",
    buyerCompanyId: "",
    contractData: "",
    clothQulaityId: "",
    quantity: 0,
    ratePerPick: 0,
    conversionRate: 0,
    warpCountMargin: 0,
    warpweight: 0,
    warpRate: 0,
    wrapAvg: 0,
    weftCountMargin: 0,
    weftweight: 0,
    weftRate: 0,
    weftAvg: 0,
    totalWeight: 0,
    fabricRatePerMeter: 0,
    weave: "",
    selvedge: "",
    description: "",
    brokerName: "",
    rateFormate: "",
    brokerRate: "",
    delieverySchedule: [],
    selectInvoice: false,
  };

  useEffect(() => {
    async function runAPIs(params) {
      setIsLoading(true);
      await getAllBuyersFromDb();
      await getAllWeaveFromDb();
      await getAllSelvedgeFromDb();
      await getAllClothQualitiesFromDb();

      setIsLoading(false);
    }
    runAPIs();
  }, []);

  useEffect(() => {
    dropDownOption();
  }, [state.buyers, state.weave, state.selvedge, state.clothQualities]);

  useEffect(() => {
    form.setFieldsValue({
      ...contract,
    });
  }, [contract]);

  const getAllBuyersFromDb = async () => {
    if (companyId) {
      let {
        data: { result },
      } = await getAllBuyers({ companyId });
      setState((prev) => ({
        ...prev,
        buyers: result,
      }));
    }
  };

  const getAllWeaveFromDb = async () => {
    if (companyId) {
      let {
        data: { result },
      } = await getAllWeave({ companyId });

      setState((prev) => ({
        ...prev,
        weave: result,
      }));
    }
  };

  const getAllSelvedgeFromDb = async () => {
    if (companyId) {
      let {
        data: { result },
      } = await getAllSelvedge({ companyId });
      setState((prev) => ({
        ...prev,
        selvedge: result,
      }));
    }
  };

  const getAllClothQualitiesFromDb = async () => {
    if (companyId) {
      let {
        data: { result },
      } = await getAllClothQualities({ companyId });
      setState((prev) => ({
        ...prev,
        clothQualities: result,
      }));
    }
  };

  const dropDownOption = () => {
    let { buyers, weave, selvedge, clothQualities } = state;

    let buyerOption = buyers.map((buyer) => {
      let optionObject = {
        label: buyer.buyerName,
        value: buyer._id,
      };
      return optionObject;
    });

    let weaveOptions = weave.map(({ weave }) => weave);

    let selvedgeOptions = selvedge.map(({ selvedge }) => selvedge);

    let clothQualitiesOptions = clothQualities.map((clothQuality) => {
      let optionObj = {
        label: `${clothQuality.reed} * ${clothQuality.pick} / ${clothQuality.warp} * ${clothQuality.weft} = ${clothQuality.width}" ${clothQuality.type}`,
        value: clothQuality._id,
      };
      return optionObj;
    });

    setState((prev) => ({
      ...prev,
      buyerOption,
      weaveOptions,
      selvedgeOptions,
      clothQualitiesOptions,
    }));
  };

  const onSelectBuyerName = (value) => {
    console.log("value=>", value);
  };

  const onSelectClothQuality = (value) => {};

  const onSelectWeave = (value) => {
    console.log("value=>", value);
  };

  const onSelectSelvedge = (value) => {
    console.log("value=>", value);
  };

  const onValuesChange = (changedValues, contractData) => {
    let selectedClothQuality = state.clothQualities.find(
      (clothQuality) => clothQuality._id === contractData.clothQulaityId
    );

    pick =
      selectedClothQuality === undefined ? pick : selectedClothQuality.pick;
    width =
      selectedClothQuality === undefined ? width : selectedClothQuality.width;

    reed =
      selectedClothQuality === undefined ? reed : selectedClothQuality.reed;
    ratePerPick = contractData.ratePerPick ? contractData.ratePerPick : 0;
    conversionRate = FIXED_TO.multiRoundOff(ratePerPick, pick);

    warpCountMargin =
      changedValues.warpCountMargin === undefined
        ? warpCountMargin
        : parseInt(changedValues.warpCountMargin);
    weftCountMargin =
      changedValues.weftCountMargin === undefined
        ? weftCountMargin
        : changedValues.weftCountMargin;
    warpRate =
      changedValues.warpRate === undefined ? warpRate : changedValues.warpRate;
    weftRate =
      changedValues.weftRate === undefined ? weftRate : changedValues.weftRate;

    warpweight = warpCountMargin
      ? (reed * width * 1.0936) / warpCountMargin / 20 / 40
      : 0;
    warpRate = contractData.warpRate ? contractData.warpRate : 0;
    weftCountMargin = contractData.weftCountMargin
      ? contractData.weftCountMargin
      : 0;
    weftweight = weftCountMargin
      ? (pick * width * 1.0936) / weftCountMargin / 20 / 40
      : 0;
    weftRate = contractData.weftRate ? contractData.weftRate : 0;
    warpAvg = FIXED_TO.multiRoundOff(warpweight, warpRate);
    weftAvg = FIXED_TO.multiRoundOff(weftweight, weftRate);

    fabricRatePerMeter = FIXED_TO.addRoundOffTripple(
      warpAvg,
      weftAvg,
      conversionRate
    );
    totalWeight = FIXED_TO.addRoundOff(weftweight, warpweight);

    form.setFieldsValue({
      conversionRate,
      warpAvg,
      warpweight: warpweight.toFixed(4),
      weftAvg,
      weftweight: weftweight.toFixed(4),
      fabricRatePerMeter,
      totalWeight,
    });
  };

  const onFinish = (fieldsValue) => {
    console.log("fieldsValue = > ", fieldsValue);
    let contractApiPayload = {
      type: "conversion",
      companyId,
      ...fieldsValue,
    };
    addConversionContractToDb(contractApiPayload);
    // dispatch(addConversion(conversion));
  };

  const addConversionContractToDb = async (paramsPayload) => {
    setIsLoading(true);
    try {
      await addConvertionContract(paramsPayload);
      Notify_Utils.openNotificationWithIcon(
        "success",
        "Conversion contract created successfully"
      );
      history.push("/contract-list");
    } catch (error) {
      Notify_Utils.openNotificationWithIcon(
        "error",
        error?.response?.data?.message || "Failed to add conversion contract"
      );
    }
    setIsLoading(false);
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  return (
    <React.Fragment>
      {isLoading ? <Loading /> : null}
      <StyledForm
        autocomplete="off"
        form={form}
        {...layout}
        name="basic"
        initialValues={contract}
        onFinish={onFinish}
        // onValuesChange={handleTotal}
        onValuesChange={onValuesChange}
        onFinishFailed={onFinishFailed}
      >
        <Row gutter={[{ xs: 0, sm: 48 }, 16]} type="flex" justify="center">
          <Col md={24} sm={18} xs={24}>
            <SubTiitle tittle=" General Info" />
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Contract #"
              name="contractNo"
              rules={[
                {
                  required: true,
                  message: "Please Enter Contract Number!",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Contract number"
                prefix={<NumberOutlined />}
              />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Buyer Company Name"
              name="buyerCompanyId"
              rules={[
                {
                  required: true,
                  message: "Please select Buyer Company Name ",
                },
              ]}
            >
              <Select defaultValue="" onChange={onSelectBuyerName}>
                <Option value="">select buyer</Option>
                {state.buyerOption.map((buyer) => (
                  <Option value={buyer.value}>{buyer.label}</Option>
                ))}
              </Select>
              {/* <Select
                placeholder="Buyer Company Name"
                prefixIcon={<UserOutlined />}
                Options={BuyerNameOption}
              /> */}
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Contract Date"
              name="contractDate"
              rules={[
                {
                  required: true,
                  message: "Please Set Contract Date!",
                },
              ]}
            >
              <DatePicker reverse="reverse" />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Cloth Quality"
              name="clothQulaityId"
              rules={[
                {
                  required: true,
                  message: "Please select Quality ",
                },
              ]}
            >
              <Select
                defaultValue=""
                placeholder="Reed * Pick / Warp * Weft = width″ Type"
                onChange={onSelectClothQuality}
              >
                <Option value="">select cloth Quality</Option>
                {state.clothQualitiesOptions.map((clothQuality) => (
                  <Option value={clothQuality.value}>
                    {clothQuality.label}
                  </Option>
                ))}
              </Select>
              {/* <Select
                placeholder="Reed * Pick / Warp * Weft = width″ Type"
                type="qualities"
                prefixIcon={<UserOutlined />}
                Options={clothQuality ? clothQuality : []}
              /> */}
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Quantity"
              name="quantity"
              rules={[
                {
                  required: true,
                  message: "Please Enter Quantity (meter)!",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Quantity (meter)"
                prefix={<UserOutlined />}
              />
            </Form.Item>
          </Col>
          {/* <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Fabric Rate Per Meter"
              name="fabric_fabric_rate_per_meter"
              rules={[
                {
                  required: true,
                  message: "Please Enter Fabric Rate/m",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Fabric Rate/m"
                prefix={<UserOutlined />}
              />
            </Form.Item>
          </Col> */}
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Rate Per Pick"
              name="ratePerPick"
              rules={[
                {
                  required: true,
                  message: "Please Enter Rate per pick",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Rate per pick"
                prefix={<UserOutlined />}
              />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Conversion Rate"
              name="conversionRate"
              rules={[
                {
                  required: true,
                  message: "Please Enter Conversion rate ",
                },
              ]}
            >
              <Input
                disabled
                placeholder="Conversion rate "
                prefix={<UserOutlined />}
              />
            </Form.Item>
          </Col>

          <Col md={24} sm={18} xs={24}>
            <SubTiitle tittle="Weight Calculator" />
          </Col>
          <Col md={22} sm={18} xs={24}>
            {/* Wrap Calculatore */}
            <CalContainer>
              <Row
                type="flex"
                justify="space-between"
                align="center"
                gutter={[16, 16]}
              >
                <Col md={6}>
                  <Form.Item
                    label="Warp Count Margin"
                    name="warpCountMargin"
                    rules={[
                      { required: true, message: "Fill Wrap Count Margin" },
                    ]}
                  >
                    <Input
                      className="text-center"
                      placeholder="Warp Count Margin"
                      type="number"
                    />
                  </Form.Item>
                </Col>

                <Col md={6}>
                  <Form.Item
                    label="Warp weight"
                    name="warpweight"
                    rules={[
                      { required: true, message: "Please Enter Wrap Weight" },
                    ]}
                  >
                    <Input
                      disabled
                      className="text-center"
                      placeholder="Wrap Weight"
                      type="number"
                    />
                  </Form.Item>
                </Col>

                <Col md={6}>
                  <Form.Item
                    label="Warp Rate"
                    name="warpRate"
                    rules={[
                      { required: true, message: "Please Enter Wrap Rate" },
                    ]}
                  >
                    <Input
                      className="text-center"
                      placeholder="Wrap Rate"
                      type="number"
                    />
                  </Form.Item>
                </Col>
                <Col md={6}>
                  <Form.Item label="Warp Avg" name="warpAvg">
                    <Input
                      initialValue={0.0}
                      className="text-center"
                      resultbox="true"
                      prefix="="
                      placeholder="0.00"
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>

              {/* Weft calculatore */}
              <Row
                type="flex"
                justify="space-between"
                align="center"
                gutter={[16, 16]}
              >
                <Col md={6}>
                  <Form.Item
                    label="Weft Count Margin"
                    name="weftCountMargin"
                    rules={[
                      { required: true, message: "Fill Weft Count Margin" },
                    ]}
                  >
                    <Input
                      className="text-center"
                      placeholder="Weft Count Margin"
                      type="number"
                    />
                  </Form.Item>
                </Col>

                <Col md={6}>
                  <Form.Item
                    label="Weft weight"
                    name="weftweight"
                    rules={[
                      { required: true, message: "Please Enter Weft Weight" },
                    ]}
                  >
                    <Input
                      disabled
                      className="text-center"
                      placeholder="Weft Weight"
                      type="number"
                    />
                  </Form.Item>
                </Col>

                <Col md={6}>
                  <Form.Item
                    label="Weft Rate"
                    name="weftRate"
                    rules={[
                      { required: true, message: "Please Enter weft Rate" },
                    ]}
                  >
                    <Input
                      className="text-center"
                      placeholder="Wrap Rate"
                      type="number"
                    />
                  </Form.Item>
                </Col>
                <Col md={6}>
                  <Form.Item label="Weft Avg" name="weftAvg">
                    <Input
                      initialValue={0.0}
                      className="text-center"
                      resultbox="true"
                      prefix="="
                      placeholder="0.00"
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row type="flex" justify="center" gutter={[16.16]}>
                <Col md={6}>
                  <Form.Item name="totalWeight" label="Total Weight">
                    <Input
                      initialValue={0.0}
                      className="text-center"
                      placeholder="0.00"
                      disabled
                    />
                  </Form.Item>
                </Col>
                {/* <Col md={6}>
                  <Form.Item name="fabricRatePerMeter" label="Total Rate">
                    <Input
                      initialValue={0.0}
                      className="text-center"
                      placeholder="0.00"
                      disabled
                    />
                  </Form.Item>
                </Col> */}
                <Col md={6}>
                  <Form.Item name="fabricRatePerMeter" label="Rate/MTR">
                    <Input
                      initialValue={0.0}
                      className="text-center"
                      placeholder="0.00"
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>
            </CalContainer>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Weave"
              name="weave"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Select defaultValue="" onChange={onSelectWeave}>
                <Option value="">select Weave</Option>
                {state.weaveOptions.map((weave) => (
                  <Option value={weave}>{weave}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.Item
              label="Selvedge"
              name="selvedge"
              rules={[
                {
                  required: false,
                },
              ]}
            >
              <Select defaultValue="" onChange={onSelectSelvedge}>
                <Option value="">select Selvedge</Option>
                {state.selvedgeOptions.map((selvedge) => (
                  <Option value={selvedge}>{selvedge}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col md={24} sm={18} xs={24}>
            <Form.Item
              label="Description"
              name="description"
              rules={[
                {
                  required: false,
                  message: "Please Enter Description!",
                },
              ]}
            >
              <TextArea />
            </Form.Item>
          </Col>
          {/* <Col md={24} sm={18} xs={24}>
            <SubTiitle tittle="Taxes" />
          </Col> */}
          {/* <Col md={24} sm={18} xs={24}>
            <Form.Item name="include_gst" valuePropName="checked">
              <Checkbox checked={true}>Include GST</Checkbox>
            </Form.Item>
          </Col> */}
          <Col md={24} sm={18} xs={24}>
            <SubTiitle tittle=" Broker Info " />
          </Col>
          <Col md={8} sm={18} xs={24}>
            <Form.Item
              label="Broker Name"
              name="brokerName"
              rules={[
                {
                  required: true,
                  message: "Please Enter Broker name",
                },
              ]}
            >
              <Input placeholder="Broker name" prefix={<UserOutlined />} />
            </Form.Item>
          </Col>
          <Col md={8} sm={18} xs={24}>
            <Form.Item
              label="Rate Format"
              name="rateFormate"
              rules={[
                {
                  required: true,
                  message: "Please Select broker Rate Format",
                },
              ]}
            >
              <Select
                defaultValue=""
                placeholder="Broker Rate Formate"
                onChange={() => {}}
              >
                <Option value="">select Rate Format</Option>
                {["Rupees PKR", "Percentage %"].map((rateFormat) => (
                  <Option value={rateFormat}>{rateFormat}</Option>
                ))}
              </Select>
            </Form.Item>
          </Col>

          <Col md={8} sm={18} xs={24}>
            <Form.Item
              label="Broker Rate"
              name="brokerRate"
              rules={[
                {
                  required: true,
                  message: "Please Enter Broker Rate",
                },
              ]}
            >
              <Input
                type="number"
                placeholder="Broker Rate"
                prefix={<UserOutlined />}
                // disabled={conversion?.broker_info?.rateFormate ? false : true}
              />
            </Form.Item>
          </Col>
          <Col md={12} sm={18} xs={24}></Col>

          <Col md={24} sm={18} xs={24}>
            <SubTiitle tittle="Delivery Scedule" />
          </Col>
          <Col md={12} sm={18} xs={24}>
            <Form.List name="delieverySchedule">
              {(fields, { add, remove }) => {
                return (
                  <div>
                    {fields.map((field) => (
                      <Space
                        key={field.key}
                        style={{ display: "flex", marginBottom: 8 }}
                        align="start"
                      >
                        <Form.Item
                          {...field}
                          name={[field.name, "date"]}
                          fieldKey={[field.fieldKey, "date"]}
                          rules={[
                            { required: true, message: "Plz Enter Date" },
                          ]}
                        >
                          <DatePicker reverse="reverse" />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, "meter"]}
                          fieldKey={[field.fieldKey, "meter"]}
                          rules={[{ required: true, message: "Input Meter" }]}
                        >
                          <Input
                            placeholder="Meter"
                            prefix={<UserOutlined />}
                          />
                        </Form.Item>
                        {fields.length > 1 ? (
                          <MinusCircleOutlined
                            onClick={() => {
                              remove(field.name);
                            }}
                          />
                        ) : null}
                      </Space>
                    ))}

                    <Form.Item>
                      <Button
                        width="187px"
                        margin="0px"
                        fontSize="16px"
                        weight="500"
                        height="auto"
                        bg="#ba3d79"
                        onClick={() => {
                          add();
                        }}
                      >
                        <PlusOutlined />
                        Add Delivery Scedule
                      </Button>
                    </Form.Item>
                  </div>
                );
              }}
            </Form.List>
          </Col>
          <Col md={12} sm={18} xs={24}></Col>
          <Col md={24} sm={18} xs={24}>
            <Form.Item
              name="selectInvoice"
              label="Select Invoice"
              rules={[
                {
                  validator: (_, value) =>
                    value
                      ? Promise.resolve()
                      : Promise.reject("Please Select Invoice"),
                },
              ]}
            >
              <RadioGroup>
                <Radio value={true}>Invoice</Radio>
                <Radio value={false}>Without Invoice</Radio>
              </RadioGroup>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Row type="flex" justify="end">
            <Col md={24}>
              <Row type="flex" justify="space-between">
                <Button
                  width="187px"
                  bg="#404E67"
                  type="primary"
                  htmlType="submit"
                >
                  <Typography
                    text="Save Contract"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button>
                {/* <Button
                  width="187px"
                  bg="#404E67"
                  type="primary"
                  onClick={() => form.resetFields()}
                >
                  <Typography
                    text="Cancel"
                    as="h5"
                    noMargin
                    weight="bold"
                    align="center"
                    color="white"
                  />
                </Button> */}
              </Row>
            </Col>
          </Row>
        </Form.Item>
      </StyledForm>
    </React.Fragment>
  );
};

const SubTiitle = ({ tittle }) => {
  return (
    <div>
      <div className="d-flex v-center">
        <Divider
          width="8px"
          radius="2px"
          height="30px"
          margin="0px 5px"
          type="vertical"
        />
        <Typography
          className="d-inline--block"
          as="h3"
          noMargin
          color={colors.darkPink}
          weight="bold"
          text={tittle}
        />
      </div>
    </div>
  );
};

export default ConversionContract;
